import { render, staticRenderFns } from "./RegionManager.vue?vue&type=template&id=26f2fbb5&"
import script from "./RegionManager.vue?vue&type=script&lang=js&"
export * from "./RegionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegionManager.vue"
export default component.exports